import { useQuery } from "@tanstack/react-query"
import instance from "../../instance"

export const useFetchDashboard=()=>{
    const fetchDashboard= async()=>{
const {data}= await instance.get(`/clients/dashboard-metrics`)
return data

    }
    const query= useQuery({
        queryFn:fetchDashboard,
        queryKey:['documents', ]
    })
return query
}